import { Injectable, isDevMode } from '@angular/core';
import { McatalogConfigDaoService } from 'src/app/dao/catalogs-dao-services/config-dao-services/config-dao.service';
import { tap, map } from 'rxjs/operators';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { Subject } from 'rxjs';
import { Gateway } from 'src/app/models/gateways-models/gateway.model';
import { GatewayProvider } from 'src/app/models/gateways-models/gateway-provider.model';
import { GatewayType } from 'src/app/models/gateways-models/gateway-type.model';
import { CatalogService } from 'src/app/models/catalogs-model/catalog-service.model';

@Injectable({
  providedIn: 'root'
})
export class McatalogConfigService {

  private refreshMCatalogConfigListener = new Subject();

  constructor(private userStorageService: UserStorageService,
              private mcatalogConfigDaoService: McatalogConfigDaoService) { }

  public getMCatalogGateways() {
    return this.mcatalogConfigDaoService.getMCatalogGateways(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const gateways = new Array<Gateway>();
        o['data']['paymentConfigs'].forEach(g => {
          const gateway = new Gateway();
          Object.assign(gateway, g);
          const provider = new GatewayProvider();
          Object.assign(provider, g['gateway']);
          gateway.Gateway = provider;
          const type = new GatewayType();
          Object.assign(type, g['type']);
          gateway.Type = type;
          gateways.push(gateway);
        });
        return gateways;
      })
    );
  }

  public getMCatalogServices() {
    return this.mcatalogConfigDaoService.getMCatalogServices(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const services = new Array<CatalogService>();
        o['data']['services'].forEach(s => {
          const service = new CatalogService();
          Object.assign(service, s);
          services.push(service);
        });
        console.dir(services);
        return services;
      })
    );
  }

  public getMCatalogConfig() {
    return this.mcatalogConfigDaoService.getMCatalogConfig(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data']['config'])
    );
  }

  public updateMCatalogServices(internalIds) {
    return this.mcatalogConfigDaoService.updateMCatalogServices(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalIds).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data'])
    );
  }

  public updateMCatalogGateways(internalIds) {
    return this.mcatalogConfigDaoService.updateMCatalogGateways(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalIds).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data'])
    );
  }

  public updateMCatalogBanner(imageUrl) {
    return this.mcatalogConfigDaoService.updateMCatalogBanner(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), imageUrl).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }
  public updateMCatalogColor(primaryColor, secondaryColor) {
    return this.mcatalogConfigDaoService.updateMCatalogColor(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), primaryColor, secondaryColor).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }
  public updateMCatalogTickets(ticketCustomer, ticketStaff) {
    return this.mcatalogConfigDaoService.updateMCatalogTickets(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), ticketCustomer, ticketStaff).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }
  public updateMCatalogInactivityTime(inactivityTime) {
    return this.mcatalogConfigDaoService.updateMCatalogInactivityTime(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), inactivityTime).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }

  public updateCatalogsConfigHelp(assistantActive) {
    return this.mcatalogConfigDaoService.updateCatalogsConfigHelp(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), assistantActive).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o)
    );
  }


  public listenRefreshMCatalogConfig() {
    return this.refreshMCatalogConfigListener.asObservable();
  }

  public refreshMCatalogConfig() {
    this.refreshMCatalogConfigListener.next();
  }
}
